<template>
  <div class="form-group">
    <label class="black title-bold">{{  questionText  }}</label>

    <div class="q-buttonlist-answer mt-3 containerButtonOption" vs-align="center" vs-type="flex"
      vs-justify="space-around" v-show="showOptions">
      <vs-button vs-type="flex" vs-justify="center" v-for="(opt, index) in optionsBase1" v-bind:key="index"
        v-if="opt <= 5" type="flat" id="nota" name="nota" class="btnOtionList nps-btn rounded-circle buttonOption"
        v-on:click="chooseOption(opt)">{{  opt  }}</vs-button>
      <div class="containerBtn2">
        <vs-button vs-type="flex" vs-justify="center" v-for="(opt, index) in optionsBase1" v-bind:key="index"
          v-if="opt > 5" type="flat" id="nota" name="nota" class="btnOtionList nps-btn rounded-circle buttonOption2"
          v-on:click="chooseOption(opt)">{{  opt  }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Survey-Nps-Question",
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    showOptions: false,
    optionsBase1: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10"
    ],
    processingApi: false,
  }),
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      }
    }
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    }
  },
  mounted() {
    this.qtAnwser = this.$store.getters.answerValue(this.questionId)
    if (this.qtAnwser) {
      this.addSelectedOptionStyle()
    }
  },
  updated() {
  },
  props: {
    questionText: { type: String },
    questionId: { type: Number },
  },
  methods: {
    allKeys() {
      if (this.qtAnwser)
        this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
      this.showOptions = true;
    },
    validNota: function (nota) {
      let notaInt = parseInt(nota, 10)
      if (Number.isInteger(notaInt)) {
        return true;
      }
      else {
        return false;
      }
    },
    enterKey() {
      if (this.validNota(this.qtAnwser)) {
        this.processingApi = true
        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId)
          .then(() => this.processingApi = false);
      } else {
        this.$emit("ErrorOccured", "Nota Inválida.", this.questionId)
      }
    },
    chooseOption(text) {
      this.removeSelectedOptionStyle()
      this.qtAnwser = text;
      if (this.validNota(this.qtAnwser)) {
        this.enterKey()
      } else {
        this.qtAnwser = this.qtAnwser + text;
        this.showOptions = false;
        this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
      }
    },
    addSelectedOptionStyle() {
      if (this.qtAnwser) {
        const ansList = document.querySelectorAll('.nps-btn')
        ansList[this.qtAnwser].classList.add('active')
        ansList[this.qtAnwser].children.forEach((el) => {
          el.setAttribute('style', 'color: var(--btn-text-color) !important')
        })
      }
    },
    removeSelectedOptionStyle() {
      if (this.qtAnwser) {
        const ansList = document.querySelectorAll('.nps-btn')
        ansList[this.qtAnwser].classList.remove('active')
        ansList[this.qtAnwser].children.forEach((el) => {
          el.setAttribute('style', '')
        })
      }
    }
  }
};

</script>

<style scoped>
.question button.btnOtionList.vs-button-primary.vs-button-flat.active {
  background: var(--btn-color) !important;
  filter: brightness(80%) !important;
}

.title-bold{
  font-family:'OxaniumBold';
  cursor: auto;
}
.buttonOption {
    width: 50px;
    height: 50px;
    padding: auto !important;
    background-color: #e4e4e4 !important;
    transition-delay: 0.1s;
  }

  .buttonOption2 {
    width: 50px;
    height: 50px;
    background-color: #e4e4e4 !important;
    transition-delay: 0.1s;
  }

  .containerButtonOption {
    width: 330px;
    margin: auto;
  }

  .containerBtn2 {
    margin-left: 30px;
  }

  @media (min-width: 450px) {
    .buttonOption {
      width: 60px;
      height: 60px;
      padding: auto !important;
    }

    .buttonOption2 {
      width: 60px;
      height: 60px;
    }

    .containerButtonOption {
      width: 400px;
      margin: auto;
    }
    .containerBtn2 {
      margin-left: 30px;
    }
  }
</style>
